<template>
  <button style="display: none" type="button" class="btn btn-primary" data-bs-toggle="modal"
    data-bs-target="#mdlEditUser" id="btnOpenEditUser">
    Open
  </button>

  <div class="modal fade" id="mdlEditUser" tabindex="-1" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit user {{user.username}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="row mt-3">
            <div class="col-12">
              <label for="txtNameClient" class="form-label">Name</label>
              <input type="text" class="form-control" id="txtNameClient" v-model="user.name" required />
              <div class="invalid-feedback">Please enter your Name.</div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label for="txtPhone" class="form-label">Phone</label>

              <input type="text" class="form-control" id="txtPhone" v-model="user.contact" />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label for="txtRole" class="form-label">Role</label>

              <input type="text" class="form-control" id="txtRole" v-model="user.role" required />
              <div class="invalid-feedback">Please enter a role.</div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <label for="selectAddress" class="form-label">Primary Address (Optional)</label>
              <select 
                id="selectAddress" 
                class="form-select" 
                v-model="user.idAddress"
                :disabled="loading || !addresses.length"
              >
                <option :value="null">-- Select an address --</option>
                <option 
                  v-for="address in addresses" 
                  :key="address.id" 
                  :value="address.id"
                >
                  {{ address.name }} - {{ address.fullAddress }}
                </option>
              </select>
              <div v-if="loading" class="form-text">Loading addresses...</div>
              <div v-if="!loading && !addresses.length" class="form-text">No addresses available for this client</div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <ul class="no-bullets">
                <li v-if="error.incomplete == true" class="text-danger">Enter the requested information</li>
                <li v-if="error.already == true" class="text-danger">The mail {{ user.username }} is already registered
                </li>
                <li v-if="error.badMail == true" class="text-danger">The mail is in the wrong format</li>
              </ul>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12">
              <button type="button" class="btn btn-primary" @click="resetPassword">
                 Reset password
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="editar">
            <i class="bi bi-save"></i> Save
          </button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" id="closeMdlEditUser">
            Close
          </button>
        </div>
      </div>
    </div>
  </div>

</template>
<script setup>
//import loadingbutton from "@/components/global/loading-button.vue";
import vtc from "@/helpers/vtc.js";
import { ref, defineExpose, defineEmits } from "vue";

const emit = defineEmits(['editado'])

const user = ref({ name: '', contact: '', role: '', idAddress: null })
const addresses = ref([])
const loading = ref(false)
const error = ref({ incomplete: false, already: false, badMail: false })

const fetchAddresses = async (clientId) => {
  if (!clientId) return;
  
  try {
    loading.value = true;
    const response = await vtc.vtcFetch('/address/getClientAddresses', { IdClient: clientId }, 'API2');
    if (!response.error) {
      addresses.value = response;
    }
  } catch (error) {
    console.error('Error fetching addresses:', error);
  } finally {
    loading.value = false;
  }
};

const open = (u) => {
  user.value = { ...u, idAddress: u.idAddress || null };
  console.log("Opening user editor for:", u);
  
  // Fetch addresses if clientId is available
  if (u.idClient) {
    console.log("Fetching addresses for client:", u.idClient);
    fetchAddresses(u.idClient);
  } else {
    console.warn("No clientId provided, skipping address fetch");
    addresses.value = []; // Clear any previous addresses
  }
  
  document.getElementById("btnOpenEditUser").click();
}


let editar = () => {
  let usr = user.value  

  vtc.vtcFetch(`/Auth/EditUser`, usr, "API2").then(function () {
    document.getElementById("closeMdlEditUser").click();
    emit('editado');
  });
}

const resetPassword = async () => {  
      if (confirm("An email will be sent")) {
        
        const res = await vtc.vtcFetch(`/Auth/ForgotPassword?username=${user.value.username}`, null, 'API2')

        if(! res.error){            
              alert("A password reset email has been sent")
          }
      }
    }

defineExpose({
  open,
});
</script>